<template>
  <div>
    <div class="app-toolbar1"><el-button type="primary" size="small" @click="toAdd">添加</el-button></div>
    <el-table :data="icons" :stripe="true" v-loading="loading" size="mini">
      <el-table-column prop="url" label="图标" width="50">
        <template slot-scope="scope">
          <img :src="filePrefix + scope.row.url" style="max-width:32px;max-height:32px;">
        </template>
      </el-table-column>
      <el-table-column prop="url" label="图标地址" width="600"></el-table-column>
      <el-table-column prop="desc" label="图标描述"></el-table-column>
      <el-table-column prop="createTime" label="上传时间" width="140"></el-table-column>
      <el-table-column fixed="right" label="操作" width="82">
        <template slot-scope="scope">
          <el-button @click="toDelete(scope.row)" type="danger" size="mini">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="query.total > 0" :page-size="query.limit" :pager-count="11" layout="total, prev, pager, next" :total="query.total" :background="true" @current-change="load" class="app-pagination"></el-pagination>

    <el-dialog title="上传图标" :visible.sync="showForm" @close="resetForm">
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true">
        <el-form-item label="上传图标" prop="icon">
          <el-upload :action="fileServer" :data="fileData" :multiple="false" :file-list="fileList" show-file-list list-type="picture" :on-remove="onFileRemove" :on-success="onUploadSuccess">
            <el-button size="mini" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="图标描述" prop="desc">
          <el-input v-model="form.desc" placeholder="请输入图标描述" :maxlength="200"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showForm = false">取 消</el-button>
        <el-button type="primary" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { calcPage } from '../../util'
import { fls } from '@/config'

export default {
  name: 'icon-manage',
  data () {
    return {
      loading: false,
      icons: [],
      query: {
        page: 1,
        limit: 10,
        total: 0
      },
      showForm: false,
      form: {
        iconId: null,
        url: null,
        desc: null
      },
      formRule: {
        url: [{ required: true, message: '请上传图标', trigger: 'blur' }]
      },
      fileServer: `${fls}/files`,
      filePrefix: `${fls}/static-file`,
      fileData: { path: 'icon' },
      fileList: []
    }
  },
  created () {
    this.load(1)
  },
  methods: {
    load (page) {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgIcons?page=${page}&limit=${this.query.limit}`
      }).then((res) => {
        let pageData = res.data.data
        this.icons = pageData.data
        this.query.page = pageData.page
        this.query.total = pageData.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    toAdd () {
      this.form = { url: null, desc: null }
      this.fileList = []
      this.showForm = true
    },
    toDelete (row) {
      this.$store.commit('confirm', { title: '提示', msg: '您确认要删除该图标吗?', data: row, scope: this, callback: this.doDelete })
    },
    doSave () {
      this.$refs.form.validate((success) => {
        if (success) {
          let iconId = this.form.iconId
          this.$http.request({
            method: !iconId ? 'post' : 'put',
            url: !iconId ? '/api/cgIcons' : `/api/cgIcons/${iconId}`,
            data: JSON.stringify(this.form)
          }).then(() => {
            this.showForm = false
            this.fileList = []
            this.load(this.query.page)
          })
        } else {
          return false
        }
      })
    },
    doDelete (result, data) {
      if (result) {
        this.$http.request({
          method: 'delete',
          url: `/api/cgIcons/${data.iconId}`
        }).then(() => {
          this.$message.success('删除成功')
          this.load(calcPage(this.query))
        })
      }
    },
    onFileRemove () {
      this.form.url = null
      this.fileList = []
    },
    onUploadSuccess (res) {
      this.form.url = res.data
      this.fileList = [{name: '图标', url: this.filePrefix + res.data}]
    },
    resetForm () {
      this.$refs.form.resetFields()
    }
  }
}
</script>
